/* eslint-disable no-console */
import {http} from '../http'
import * as corePhotos from '../../coreApi/photos'

import {APIResponse} from '../types'
import {ResourceID} from '../../../types'
import {handleError} from '../handleError'

interface ReprocessAlbumFacesResult {
  photoCount: number
}

type ReprocessAlbumFacesReturn = APIResponse<ReprocessAlbumFacesResult>

export interface ReprocessAlbumFaces {
  (
    clientID: ResourceID,
    albumID: ResourceID,
  ): Promise<ReprocessAlbumFacesReturn>
}

const ERROR_PATH = 'api.photos.reprocessAlbumFaces()'
const GENERIC_ERROR = 'failed'

export const reprocessAlbumFaces: ReprocessAlbumFaces = async (
  clientID,
  albumID,
) => {
  let resolvedResponse: ReprocessAlbumFacesReturn

  try {
    const params = {
      ClientID: parseInt(clientID, 10),
      AlbumID: parseInt(albumID, 10),
    }

    const response = await corePhotos.reprocessAlbumFaces(http, params)

    resolvedResponse = {
      result: 'success',
      data: {photoCount: response.data.PhotoCount},
    }
  } catch (e) {
    resolvedResponse = handleError(ERROR_PATH, GENERIC_ERROR, e)
  }

  return Promise.resolve(resolvedResponse)
}
